export default {
  ru: {
    averageTiming: 'Среднее время МИС → CDP',
    averagePeriods: { 24: 'За 24 часа', 72: 'За 3 дня', 168: 'За 7 дней' },
    averageSample: 'Учтено записей: {count} из {total}',
    averageTimezoneMissing: 'Для части дат МИС не подтверждён часовой пояс.',
    averageHint:
      'По новым записям всего аккаунта, впервые полученным CDP за период. Без повторных событий и импорта истории. Фильтры таблицы не влияют; отсутствующие и отрицательные интервалы исключены.',
    averageAsOf: 'Расчёт на {date} · обновление не чаще раза в минуту.',
    timingTitle: 'Прохождение данных',
    fullPath: 'Весь путь МИС → CDP',
    fullPathHint:
      'От создания записи в МИС до её первого сохранения в CDP. Нажмите для просмотра этапов.',
    timingHint:
      'Весь путь — от создания записи в МИС до её первого сохранения в CDP. Доставка отдельного события MRES → CDP показана ниже и не подменяет полный интервал.',
    timingDates: 'Даты создания',
    misCreated: 'Дата создания МИС',
    mresCreated: 'Дата создания MRES',
    crmCreated: 'Дата создания CRM',
    cdpCreated: 'Дата создания CDP',
    cdpReceived: 'Получено CDP',
    eventDelay: 'Доставка события',
    eventDelayRoute: 'Доставка события · MRES → CDP',
    misToMres: 'МИС → MRES',
    mresToCdp: 'MRES → CDP · первое появление',
    misToCdp: 'МИС → CDP · первое появление',
    timingMissing: 'Нет данных',
    crmNotSent: 'Не передано источником',
    misTimezoneUnknown:
      'Дата МИС передана без часового пояса или в неподдерживаемом формате. Показано исходное значение; задержка от МИС не рассчитывается.',
    firstArrivalHint:
      'Первое появление может относиться к первоначальному импорту. Этот интервал не является скоростью текущего обновления.',
    clockMismatch: 'Проверьте часы / даты источника',
    timingSeconds: '{value} с',
    timingMinutes: '{value} мин',
    timingHours: '{value} ч',
    timingDays: '{value} дн',
    timingTimezone: 'Даты с часовым поясом показаны в {zone}.',
  },
  en: {
    averageTiming: 'Average MIS → CDP time',
    averagePeriods: {
      24: 'Last 24 hours',
      72: 'Last 3 days',
      168: 'Last 7 days',
    },
    averageSample: 'Records included: {count} of {total}',
    averageTimezoneMissing: 'Some MIS dates have no confirmed timezone.',
    averageHint:
      'New records across the account, first received by CDP in each period. Repeated events and historical imports excluded. Table filters do not apply; missing and negative intervals excluded.',
    averageAsOf: 'Calculated at {date} · refreshed at most once per minute.',
    timingTitle: 'Data transfer',
    fullPath: 'Full path MIS → CDP',
    fullPathHint:
      'From record creation in MIS to first storage in CDP. Click to see the stages.',
    timingHint:
      'The full path runs from record creation in MIS to first storage in CDP. Individual MRES → CDP event delivery is shown separately below.',
    timingDates: 'Creation dates',
    misCreated: 'MIS created at',
    mresCreated: 'MRES created at',
    crmCreated: 'CRM created at',
    cdpCreated: 'CDP created at',
    cdpReceived: 'Received by CDP',
    eventDelay: 'Event delivery',
    eventDelayRoute: 'Event delivery · MRES → CDP',
    misToMres: 'MIS → MRES',
    mresToCdp: 'MRES → CDP · first arrival',
    misToCdp: 'MIS → CDP · first arrival',
    timingMissing: 'No data',
    crmNotSent: 'Not provided by source',
    misTimezoneUnknown:
      'The MIS timestamp has no timezone or uses an unsupported format. The source value is shown; MIS latency is not calculated.',
    firstArrivalHint:
      'First arrival may be the initial import. This interval does not measure the current update speed.',
    clockMismatch: 'Check clocks / source timestamps',
    timingSeconds: '{value} s',
    timingMinutes: '{value} min',
    timingHours: '{value} h',
    timingDays: '{value} d',
    timingTimezone: 'Zoned timestamps are displayed in {zone}.',
  },
};
